import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

export default function StatementSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const text = textRef.current;
    if (!section || !text) return;

    const items = text.querySelectorAll("[data-reveal]");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 75%",
        toggleActions: "play none none none",
      },
    });

    tl.fromTo(
      items,
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, stagger: 0.15, ease: "power3.out" }
    );

    return () => {
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-[#F4F4F4] rounded-t-[40px] py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-14 mt-[-40px] relative z-10"
    >
      <div ref={textRef} className="max-w-7xl mx-auto text-right">
        <h2
          data-reveal
          className="font-heading font-bold uppercase text-[28px] sm:text-[38px] md:text-[52px] lg:text-[72px] text-[#0A0A0A] tracking-tight leading-[0.92] max-w-4xl ml-auto"
        >
          MEISTERBETRIEB
          <br />
          MIT WEITBLICK UND PRÄZISION
        </h2>
        <p
          data-reveal
          className="mt-8 text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl ml-auto"
        >
          Planung, Installation und Wartung Ihrer Photovoltaik, Speicher und Wärmepumpe — alles von einem Meisterbetrieb am Niederrhein. Kein Subunternehmer-Chaos, ein Ansprechpartner.
        </p>
        <a
          data-reveal
          href="/kontakt"
          className="inline-flex items-center mt-8 px-8 py-4 rounded-full bg-[#0A0A0A] text-white text-sm font-medium hover:bg-[#0A0A0A]/85 transition-colors ml-auto"
        >
          Kostenlose Erstberatung
        </a>
      </div>
    </section>
  );
}